import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutlineTwoTone } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AccountCreatedSuccess = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box sx={{ textAlign: 'center', maxWidth: 500, px: 2, py: 2 }}>
            <Alert icon={false} severity="success" sx={{ alignItems: 'center', flexDirection: 'column', mb: 3 }}>
                <CheckCircleOutlineTwoTone fontSize="large" />
                <Typography variant="h3" fontWeight="bold">
                    {t('AccountCreatedSuccessTitle')}
                </Typography>
                <Typography sx={{ fontSize: '17px' }}>{t('AccountCreatedSuccessDescription')}</Typography>
            </Alert>

            <Typography sx={{ mb: 2 }}>{t('AccountCreatedSuccessHint')}</Typography>

            <Button variant="contained" color="primary" onClick={() => navigate('/login')}>
                {t('GoToLogin')}
            </Button>
        </Box>
    );
};

export default AccountCreatedSuccess;
